// ----------------------------------------------------------------------

import { ButtonOwnProps } from "@mui/material";

declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    primary: true;
    secondary: true;
    tertiary: true;
  }
}

interface ExxtendButtonOwnProps extends ButtonOwnProps {
  primary: React.CSSProperties;
  secondary: React.CSSProperties;
  tertiary: React.CSSProperties;
}

const button = {
  primary: {},
  secondary: {},
  tertiary: {},
} as ExxtendButtonOwnProps;

export default button;
